// extracted by mini-css-extract-plugin
module.exports = {"mains":"View4_mains__2pXYt","user":"View4_user__ej8sm"};